import { render, staticRenderFns } from "./package-select-list.vue?vue&type=template&id=b2c35b96&"
import script from "./package-select-list.vue?vue&type=script&lang=js&"
export * from "./package-select-list.vue?vue&type=script&lang=js&"
import style0 from "./package-select-list.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "package-select-list.vue"
export default component.exports